import Vue from 'vue'
import App from './App.vue'

if (process.env.VUE_APP_SCRIPT_TEMPLATE) {
  require(`../script-templates/${process.env.VUE_APP_SCRIPT_TEMPLATE}.scripts`)()
}

// Router + Store + Sync
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
sync(store, router)

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { dom, library } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { fad } from '@fortawesome/pro-duotone-svg-icons'
import { faPagelines } from '@fortawesome/free-brands-svg-icons'
dom.watch() // Allows use of <i class="fas".../> which can be added via coding plain text in the CMS
library.add(fas, far, faPagelines, fad, fal)
Vue.component('fa', FontAwesomeIcon)

Vue.config.productionTip = false
export const bus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
